import TestbuyFormPhotos from "./photos";
import PriorityIcon from "@coworker/reusable/svg/priority-exclamation-sign.svg?react";
import { Image } from "@coworker/types/lib/tasks/base";
interface ConfigWidgetProps {
  //Where does it get icon from?
  icon: React.ReactNode;
  lblColor: string;
  overridePadding: string;
}

interface TaskUploadPhotosWidgetProps {
  images: Image[] | undefined;
  updateImages: (images: Image[]) => void;
  taskId: string;
}

//Wrapper to help migrate to typescript, when changing something please use this instead.
export default function TaskUploadPhotosWidget({
  taskId,
  updateImages,
  images,
}: TaskUploadPhotosWidgetProps) {
  const config: ConfigWidgetProps = {
    icon: <PriorityIcon />,
    lblColor: "var(--grey900)",
    overridePadding: "32px 16px 32px 24px",
  };

  return (
    <TestbuyFormPhotos
      conf={config}
      formType={"testbuy"}
      value={images}
      onChange={updateImages}
      taskPath={`/tasks/${taskId}`}
      last={undefined}
    />
  );
}
